// Function to check if coordinates are within Haiti's boundaries
export function isInHaiti(lat: number, lon: number): boolean {
  // Haiti's approximate bounding box
  const haitiBounds = {
    minLat: 17.9, // Southern boundary
    maxLat: 20.1, // Northern boundary
    minLon: -74.5, // Western boundary
    maxLon: -71.6  // Eastern boundary
  };
  
  return (
    lat >= haitiBounds.minLat && 
    lat <= haitiBounds.maxLat && 
    lon >= haitiBounds.minLon && 
    lon <= haitiBounds.maxLon
  );
}
